<template>
    <app-layout title="View Penyusunan Dokumen Pengadaan">
        <View :dataViewDokumenPengadaan="dataViewDokumenPengadaan" :header="header" />
    </app-layout>
</template>

<script>
import { defineComponent } from 'vue';
import View from './View'

export default defineComponent({
    components: {
        View,
    },
    props: {
        dataViewDokumenPengadaan: Object,
        header: {
            type: Boolean,
            default: true,
        },
    }
});
</script>
